import { render, staticRenderFns } from "./TreatmentPrecaution.vue?vue&type=template&id=0975feb6&scoped=true&lang=pug&"
import script from "./TreatmentPrecaution.vue?vue&type=script&lang=js&"
export * from "./TreatmentPrecaution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0975feb6",
  null
  
)

export default component.exports